import { createContext, useContext, useState } from "react"

export type MapContext = {
	map: L.Map | null
	setMap: (map: L.Map | null) => void
	focusedClearCutId?: string
	setFocusedClearCutId: (id?: string) => void
	/** Report whose perimeter is currently being edited on the map, if any. */
	editingPerimeterReportId?: string
	setEditingPerimeterReportId: (id?: string) => void
} | null
const MapCtx = createContext<MapContext>(null)

export const useMapInstance = () => {
	const context = useContext<MapContext>(MapCtx)
	if (!context)
		throw new Error("useMapInstance must be used within a MapProvider")
	return context
}

export const MapProvider = ({ children }: { children: React.ReactNode }) => {
	const [map, setMap] = useState<L.Map | null>(null)
	const [focusedClearCutId, setFocusedClearCutId] = useState<string>()
	const [editingPerimeterReportId, setEditingPerimeterReportId] =
		useState<string>()
	return (
		<MapCtx.Provider
			value={{
				focusedClearCutId,
				setFocusedClearCutId,
				editingPerimeterReportId,
				setEditingPerimeterReportId,
				map,
				setMap
			}}
		>
			{children}
		</MapCtx.Provider>
	)
}
